namespace SP {
    export enum RefundType {
        Refund = 1,
        Gift_card = 2,
        No_Refund = 3,
    }
}